// This function converts the string to lowercase, then perform the conversion
export function toLowerCaseNonAccentVietnamese(str: string) {
  str = str.toLowerCase();

  str = str.replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a');
  str = str.replace(/[èéẹẻẽêềếệểễ]/g, 'e');
  str = str.replace(/[ìíịỉĩ]/g, 'i');
  str = str.replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o');
  str = str.replace(/[ùúụủũưừứựửữ]/g, 'u');
  str = str.replace(/[ỳýỵỷỹ]/g, 'y');
  str = str.replace(/đ/g, 'd');

  return str;
}

// Just for better performance, caching the project name and its non-vietnamese form
// to prevent performing too many conversions.
const CACHED_CONVERTED_VIETNAMESE_PROJECT_NAME = new Map<string, string>();

export function toLowerCaseNonAccentVietnameseMemo(
  projectName: string
): string {
  const cachedNonVietnameseProjectName = CACHED_CONVERTED_VIETNAMESE_PROJECT_NAME.get(
    projectName
  );

  if (cachedNonVietnameseProjectName) {
    return cachedNonVietnameseProjectName;
  }

  const nonVietnameseProjectName = toLowerCaseNonAccentVietnamese(projectName);
  CACHED_CONVERTED_VIETNAMESE_PROJECT_NAME.set(
    projectName,
    nonVietnameseProjectName
  );
  return nonVietnameseProjectName;
}
